import { Group, Button, Badge, Tooltip } from '@mantine/core';
import { Users, Calendar, Plus, Send, DollarSign, Upload } from 'react-feather';
import { ButtonToggle } from '../../../../components/common';

export type CoachesSubTab = 'assignments' | 'schedule' | 'compensation';

interface CoachesSubNavProps {
  activeSubTab: CoachesSubTab;
  onSubTabChange: (tab: CoachesSubTab) => void;
  onAddPotentialCoaches: () => void;
  onSendAvailabilityRequest: () => void;
  hasSelectedCoaches: boolean;
  selectedCount: number;
  isCompensationConfigured?: boolean | null;
  isEmailDisabled?: boolean;
  // MED-672
  onUploadPartnerCoaches?: () => void;
  showUploadPartnerCoaches?: boolean;
}

export function CoachesSubNav({
  activeSubTab,
  onSubTabChange,
  onAddPotentialCoaches,
  onSendAvailabilityRequest,
  hasSelectedCoaches,
  selectedCount,
  isCompensationConfigured,
  isEmailDisabled,
  onUploadPartnerCoaches,
  showUploadPartnerCoaches,
}: CoachesSubNavProps) {
  // MED-663 AC10/AC15: Disable send button when compensation not configured
  const compensationNotConfigured = isCompensationConfigured === false;
  // MED-579: Disable send button when email toggle is off
  const sendDisabled = !hasSelectedCoaches || compensationNotConfigured || !!isEmailDisabled;
  const sendTooltip = isEmailDisabled
    ? 'This email feature has been turned off for this cohort. To enable it, go to Cohort Settings > Email Settings.'
    : compensationNotConfigured
      ? 'Configure compensation before sending availability requests'
      : !hasSelectedCoaches
        ? 'Select one or more coaches to send a request'
        : '';
  return (
    <Group justify="space-between">
      {/* Left: Sub-tabs */}
      <ButtonToggle
        options={[
          { value: 'assignments', label: 'Coaches & Assignments', icon: Users },
          { value: 'schedule', label: 'Schedule', icon: Calendar },
          { value: 'compensation', label: 'Compensation', icon: DollarSign },
        ]}
        value={activeSubTab}
        onChange={onSubTabChange}
      />

      {/* Right: Action buttons (only for assignments/schedule tabs) */}
      {activeSubTab !== 'compensation' && (
        <Group gap="xs">
          <Button
            variant="outline"
            color="gray"
            bg="white"
            style={{ borderColor: '#E8E6E3' }}
            leftSection={<Plus size={16} />}
            onClick={onAddPotentialCoaches}
          >
            Add Potential Coaches
          </Button>
          {showUploadPartnerCoaches && onUploadPartnerCoaches && (
            <Button
              variant="outline"
              color="gray"
              bg="white"
              style={{ borderColor: '#E8E6E3' }}
              leftSection={<Upload size={16} />}
              onClick={onUploadPartnerCoaches}
            >
              Upload Partner Coaches
            </Button>
          )}
          <Tooltip label={sendTooltip} disabled={!sendDisabled}>
            <Button
              leftSection={<Send size={16} />}
              onClick={onSendAvailabilityRequest}
              disabled={sendDisabled}
              rightSection={
                hasSelectedCoaches && !compensationNotConfigured ? (
                  <Badge size="sm" variant="light" color="white">
                    {selectedCount}
                  </Badge>
                ) : undefined
              }
            >
              Send Availability Request
            </Button>
          </Tooltip>
        </Group>
      )}
    </Group>
  );
}

export default CoachesSubNav;
